import { render, staticRenderFns } from "./SanmerList.vue?vue&type=template&id=45d68056"
import script from "./SanmerList.vue?vue&type=script&lang=js"
export * from "./SanmerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports